import React, { FC } from 'react';
import { FaPlus } from 'react-icons/fa6';
import { IconProps } from './common/iconProps';

export const PlusIcon: FC<IconProps> = ({ className }) => <FaPlus className={className} />;
